export default __webpack_public_path__ + "static/media/cancel.dae01c17.svg";